/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "integrations/x12/models.proto" (package "rd.integrations.x12", syntax proto3)
// tslint:disable
// @ts-nocheck
/**
 * The standart sometimes uses PO and sometimes uses 850.
 * The same way it sometimes uses FA and sometimes uses 997.
 * It is possible that there are cases where an PO is not 850 or an FA is not 997.
 * We will use the standard names for now.
 *
 * @generated from protobuf enum rd.integrations.x12.FunctionalIdentifierCode
 */
export enum FunctionalIdentifierCode {
    /**
     * @generated from protobuf enum value: UNKNOWN_FIC = 0;
     */
    UNKNOWN_FIC = 0,
    /**
     * Functional Acknowledgment (997)
     *
     * @generated from protobuf enum value: FA = 1;
     */
    FA = 1,
    /**
     * Purchase Order (850 Purchase Order, 855 Purchase Order
     *
     * @generated from protobuf enum value: PO = 2;
     */
    PO = 2,
    /**
     * Acknowledgment, 860 Purchase Order Acknowledgment, 865
     * Purchase Order Acknowledgment)
     *
     * Ship Notice/Manifest (856 Ship Notice/Manifest - ASN)
     *
     * @generated from protobuf enum value: SH = 3;
     */
    SH = 3,
    /**
     * Invoice (810 Invoice)
     *
     * @generated from protobuf enum value: IN = 4;
     */
    IN = 4,
    /**
     * Price/Sales Catalog (832)
     *
     * @generated from protobuf enum value: PR = 6;
     */
    PR = 6
}
/**
 * @generated from protobuf enum rd.integrations.x12.TransactionSetIdentifierCode
 */
export enum TransactionSetIdentifierCode {
    /**
     * @generated from protobuf enum value: UNKNOWN_TSIC = 0;
     */
    UNKNOWN_TSIC = 0,
    /**
     * Invoice
     *
     * @generated from protobuf enum value: INVOICE = 810;
     */
    INVOICE = 810,
    /**
     * Price/Sales Catalog
     *
     * @generated from protobuf enum value: PRICE_SALES_CATALOG = 832;
     */
    PRICE_SALES_CATALOG = 832,
    /**
     * Purchase Order
     *
     * @generated from protobuf enum value: PURCHASE_ORDER = 850;
     */
    PURCHASE_ORDER = 850,
    /**
     * Ship Notice/Manifest - ASN
     *
     * @generated from protobuf enum value: SHIP_NOTICE_MANIFEST = 856;
     */
    SHIP_NOTICE_MANIFEST = 856,
    /**
     * Functional Acknowledgment
     *
     * @generated from protobuf enum value: FUNCTIONAL_ACKNOWLEDGMENT = 997;
     */
    FUNCTIONAL_ACKNOWLEDGMENT = 997
}
/**
 * @generated from protobuf enum rd.integrations.x12.AcknowledgeCode
 */
export enum AcknowledgeCode {
    /**
     * @generated from protobuf enum value: ACKNOWLEDGE_CODE_UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * A
     *
     * @generated from protobuf enum value: ACKNOWLEDGE_CODE_ACCEPTED = 1;
     */
    ACCEPTED = 1,
    /**
     * R
     *
     * @generated from protobuf enum value: ACKNOWLEDGE_CODE_REJECTED = 2;
     */
    REJECTED = 2,
    /**
     * E
     *
     * @generated from protobuf enum value: ACKNOWLEDGE_CODE_ACCEPTED_BUT_ERRORS_WERE_NOTED = 3;
     */
    ACCEPTED_BUT_ERRORS_WERE_NOTED = 3,
    /**
     * P
     *
     * @generated from protobuf enum value: ACKNOWLEDGE_CODE_PARTIALLY_ACCEPTED = 4;
     */
    PARTIALLY_ACCEPTED = 4
}
